import FilterOption from '@/domain/FilterOption'
import { defaultPressPageOffset, defaultPressPageSize } from '@/infrastructure/Configuration'

export default {
  labelsLoaded: false,
  loading: 0,
  pressReleases: [],
  filters: {
    areas: [],
    topics: [],
    years: []
  },
  topics: {},
  areas: {},
  years: [],
  topicDropdownOptions: [],
  areaDropdownOptions: [],
  yearDropdownOptions: [],
  pagination: {
    offset: defaultPressPageOffset,
    limit: defaultPressPageSize,
    total: 0,
    totalPages: 0
  },
  selectedArea: FilterOption.fromJSON({
    name: '',
    key: 'allAreas',
    isDisabled: false
  }),
  selectedTopic: FilterOption.fromJSON({
    name: '',
    key: 'allTopics',
    isDisabled: false
  }),
  selectedYear: FilterOption.fromJSON({
    name: '',
    key: 'allYears',
    isDisabled: false
  }),
  isMobileMenuToggled: false,
  queryParamError: false
}
